export default {
      id: "partner-usage",
      viewBox: "0 0 20 20",
      url: "/assets/" + "icons.svg#partner",
      toString: function () {
        return this.url;
      }
    }